import { Component, OnInit, Input } from "@angular/core";
import { MDBModalRef } from "ng-uikit-pro-standard";
import * as moment from "moment";
import { AppService } from "src/app/core/app/app.service";
@Component({
  selector: "ll-calendar-picker",
  templateUrl: "./calendar-picker.component.html",
  styleUrls: ["./calendar-picker.component.scss"]
})
export class CalendarPickerComponent implements OnInit {
  @Input() header: string;
  @Input() subheader: string;
  @Input() save: Function;
  @Input() cancel: Function;
  @Input() singleDate: boolean;
  firstDate: Date;
  secondDate: Date;
  constructor(public app: AppService, public modalRef: MDBModalRef) {}
  currentMonth: Date;

  ngOnInit(): void {
    this.currentMonth = new Date();
  }

  next() {
    this.currentMonth = moment(this.currentMonth)
      .add(1, "M")
      .toDate();
  }

  previous() {
    this.currentMonth = moment(this.currentMonth)
      .subtract(1, "M")
      .toDate();
  }

  get month(): string {
    return moment(this.currentMonth).format("MMMM YYYY");
  }

  get dates(): Date[] {
    let start = moment(this.currentMonth).startOf("month");
    let day = start.weekday();
    let dates: Date[] = [];
    for (var i = 0; i < 35; i++) {
      let offset = day - i;
      let date: Date;
      if (i <= day)
        date = moment(start)
          .subtract(offset, "days")
          .toDate();
      else
        date = moment(start)
          .add(-1 * offset, "days")
          .toDate();
      dates.push(date);
    }
    return dates;
  }
  select(date: Date) {
    //Case Nothing selected
    if (
      (this.firstDate == null && this.secondDate == null) ||
      this.singleDate == true
    ) {
      this.firstDate = date;
      return;
    }
    //Case: first date already selected
    else if (this.firstDate != null && this.secondDate == null) {
      if (this.isSameDate(this.firstDate, date)) {
        this.firstDate = null;
        return;
      } else {
        this.secondDate = date;
        return;
      }
    }
    //Case 3: Both are Selected
    else if (this.isSameDate(this.firstDate, date)) {
      this.firstDate = this.secondDate;
      this.secondDate = null;
      return;
    } else if (this.isSameDate(this.secondDate, date)) {
      this.secondDate = null;
      return;
    } else {
      this.secondDate = date;
      return;
    }
  }

  isSameDate(a: Date, b: Date): boolean {
    return moment(a).format("MMM DD YYYY") == moment(b).format("MMM DD YYYY");
  }

  get isRange(): boolean {
    return this.firstDate != null && this.secondDate != null;
  }

  getEndOfDay(date: Date): Date {
    return moment(date)
      .endOf("d")
      .toDate();
  }

  submit() {
    this.modalRef.hide();
    if (this.isRange) {
      if (moment(this.firstDate).isBefore(moment(this.secondDate))) {
        this.save(
          this.firstDate,
          moment(this.secondDate)
            .add(1, "d")
            .toDate()
        );
      } else {
        this.save(
          this.secondDate,
          moment(this.firstDate)
            .add(1, "d")
            .toDate()
        );
      }
    } else {
      this.save(
        this.firstDate,
        moment(this.firstDate)
          .add(1, "d")
          .toDate()
      );
    }
  }

  isInRange(date: Date) {
    return (
      this.firstDate != null &&
      this.secondDate != null &&
      !this.isSelected(date) &&
      (moment(date).isBetween(
        moment(this.firstDate),
        moment(this.secondDate)
      ) ||
        moment(date).isBetween(moment(this.secondDate), moment(this.firstDate)))
    );
  }
  get currentTimeAtVenue(): moment.Moment {
    if (this.app.state.venue != null)
      return moment.tz(this.app.state.venue.cityTimezone);
    return moment();
  }

  get isPastMidnightAtVenue(): boolean {
    return this.currentTimeAtVenue.hour() < 4;
  }
  isThisMonth(date: Date) {
    return this.currentMonth.getMonth() != date.getMonth();
  }

  isToday(date: Date) {
    var dateString = moment(date).format("MM/DD/YYYY");
    if (this.isPastMidnightAtVenue)
      return (
        this.currentTimeAtVenue.subtract(1, "d").format("MM/DD/YYYY") ==
        moment(date).format("MM/DD/YYYY")
      );

    return (
      this.currentTimeAtVenue.format("MM/DD/YYYY") ==
      moment(date).format("MM/DD/YYYY")
    );
  }

  isSelected(date: Date) {
    return (
      (this.firstDate != null && this.isSameDate(this.firstDate, date)) ||
      (this.secondDate != null && this.isSameDate(this.secondDate, date))
    );
  }
}
